import { useId } from 'react';
import { Switch as BaseSwitch } from '@base-ui/react/switch';

/** An on/off setting that applies right away. Use Checkbox inside forms that are saved later. */
const Switch = ({ label, description, checked, defaultChecked, onCheckedChange, disabled = false }) => {
  const id = useId();

  return (
    <div className="comp-switch" data-disabled={disabled ? 'true' : undefined}>
      <div className="comp-switch__text">
        <label htmlFor={id} className="comp-switch__label">
          {label}
        </label>
        {description && (
          <p className="comp-switch__description" id={`${id}-description`}>
            {description}
          </p>
        )}
      </div>
      <BaseSwitch.Root id={id} className="comp-switch__track" checked={checked} defaultChecked={defaultChecked} onCheckedChange={onCheckedChange} disabled={disabled} aria-describedby={description ? `${id}-description` : undefined}>
        <BaseSwitch.Thumb className="comp-switch__thumb" />
      </BaseSwitch.Root>
    </div>
  );
};

export default Switch;
